var map = {
	"./01-convert-binary-short-name-setting.js": 413,
	"./02-store-settings-in-overlayplugin.js": 414,
	"./03-convert-light-theme.js": 415,
	"./04-convert-spell-layout.js": 416,
	"./05-copy-spell-tts.js": 417,
	"./06-change-critical-hp-setting-key.js": 418,
	"./07-convert-auto-hide-to-options.js": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;